enum NavigationEnum {
  Main = -1
}

export default NavigationEnum;
